export const track = (name: string, payload?: object) => {
  if (typeof window !== 'undefined') {
    window.LIFE_CYCLE_EVENT_BUS?.trigger(name, payload);
  }
};

export const lifeCycleTrack = (name: string, payload?: object) => {
  if (typeof window !== 'undefined') {
    window.LIFE_CYCLE_EVENT_BUS?.lifeCycle.trigger(name, payload);
  }
};
